import type { PolyLine2 } from "geom/polyLine2Types";

export interface RenderedPerspectiveLines {
  aboveGroundLines: PolyLine2[];
  aboveGroundHatchLines: PolyLine2[];
  groundLines: PolyLine2[];
  groundHatchLines: PolyLine2[];
  belowGroundLines: PolyLine2[];
  belowGroundHatchLines: PolyLine2[];
  crossSectionLines: PolyLine2[];
  crossSectionHatchLines: PolyLine2[];
}
export function renderedPerspectiveLinesNew(
  aboveGroundLines: PolyLine2[] = [],
  groundLines: PolyLine2[] = [],
  belowGroundLines: PolyLine2[] = [],
  aboveGroundHatchLines: PolyLine2[] = [],
  groundHatchLines: PolyLine2[] = [],
  belowGroundHatchLines: PolyLine2[] = [],
  crossSectionLines: PolyLine2[] = [],
  crossSectionHatchLines: PolyLine2[] = [],
): RenderedPerspectiveLines {
  return {
    aboveGroundLines,
    aboveGroundHatchLines,
    groundLines,
    groundHatchLines,
    belowGroundLines,
    belowGroundHatchLines,
    crossSectionLines,
    crossSectionHatchLines,
  };
}
